module.exports = function () { /* empty */ };



//////////////////
// WEBPACK FOOTER
// /Users/qixian.cs/Documents/GitHub/ant-design-pro-site/scaffold/node_modules/core-js/library/modules/_add-to-unscopables.js
// module id = 451
// module chunks = 0